import { NgModule } from '@angular/core';
import { RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ReceiversComponent } from './receivers.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PreferencesResolver } from 'shared/preferences/preferences.resolver';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'receivers/:page',
        component: ReceiversComponent,
        canActivate: [AuthGuard],
        resolve: {
          permissions: PermissionsResolver,
          preferences: PreferencesResolver,
        },
      },
      {
        path: 'receivers',
        redirectTo: 'receivers/my',
        pathMatch: 'full',
      },
    ])
  ],
  exports: [RouterModule],
})
export class ReceiversRoutingModule { }
